<script lang="ts">
import { defineComponent, h as createElement } from 'vue';
import MdContent from '../MdContent/MdContent.vue';

type MdTag = 'md-content';
export default defineComponent({
  functional: true,
  props: {
    mdTag: {
      type: String,
      default: 'div',
    },
  },
  render(vue2CreateElement, context) {
    console.log('MdTagSwitcher', context, Object.keys(context.listeners), context.slots());
    console.log('MdTAgSwitcher');
    const mdTag: MdTag = context?.props?.mdTag ?? 'md-content';
    switch (mdTag) {
      case 'md-content':
        return createElement(
          MdContent,
          {
            ...context.data,
          },
          context.children
        );
      default:
        return createElement(
          'div',
          {
            ...context.data,
            on: context.listeners,
          },
          context.children
        );
    }
  },
});
</script>
